import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/styles/global.less";

import AOS from "aos";
import "aos/dist/aos.css";

// import Observe from "@/directives/observe";

// Vue.directive("observe", Observe);

AOS.init();

router.beforeEach((to, from, next) => {
  let pageTitle = "YOLEE";

  if (to.name === "Home") {
    pageTitle = "YOLEE - Home";
  } else if (to.name === "MainCategory") {
    pageTitle = `YOLEE - Category/${to.params.mainCategoryId}`;
  } else if (to.name === "SubCategory") {
    pageTitle = `YOLEE - SubCategory/${to.params.subCategoryId}`;
  } else if (to.name === "ProductDetail") {
    pageTitle = `YOLEE - Product/${to.params.id}`;
  } else if (to.name === "Contact") {
    pageTitle = "YOLEE - Contact";
  } else if (to.name === "About") {
    pageTitle = "YOLEE - About Us";
  } else if (to.name === "Policy") {
    pageTitle = "YOLEE - Policy";
  } else if (to.name === "TermsOfService") {
    pageTitle = "YOLEE - Terms of Service";
  } else {
    pageTitle = "YOLEE"; // 默认
  }

  document.title = pageTitle;
  next();
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
